<template style="width: 0%; height: 0%;">
  <div class="login">
    <img class="f" src="../../assets/img_login_bg.png" alt="" />
    <div class="login-content">
      <div class="login-content-right">
        <div class="txt_style" v-if="!forget">{{ SystemNM }}</div>
        <div class="txt_style" v-if="forget">修改密码</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="top">
          <div v-if="!forget">
            <el-form-item prop="name" label="账号">
              <el-input v-model="ruleForm.UserID" placeholder="请输入账号"></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 10px;" prop="password" label="密码">
              <el-input type="password" v-model="ruleForm.PWD" placeholder="请输入密码"></el-input>
            </el-form-item>
            <div class="Pass_style" @click="forget = true">
              <p>忘记密码</p>
            </div>
            <el-form-item style="width: 85%; margin-bottom: 5px;"></el-form-item>
            <el-form-item>
              <el-button type="primary" @click="login()" :loading="loadding" style="
                        background-color: #66b1ff !important;
                        border-color: #66b1ff !important;
                      ">
                {{ loadding ? '登录中' : '登录' }}
              </el-button>
            </el-form-item>
          </div>
        </el-form>
        <!-- <p style="margin-left:120px;">  <span>还没账号？</span> <span style="color: rgba(36, 153, 255, 1);">立即注册</span></p> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      forget: false,
      loadding: false,
      language: true,
      ruleForm: {
        UserID: '',
        PWD: '',
      },
      CompanyLogo: '',
      CompanyNM: '',
      SystemNM: ''
    }
  },
  created() {
    let languageConf = localStorage.getItem('language');
    this.$i18n.locale = languageConf != '' && languageConf != 'null' && languageConf != undefined ? localStorage.getItem('language') : 'ch';
    window.localStorage.clear();
    window.sessionStorage.clear();
    localStorage.setItem('language', this.$i18n.locale);
  },
  methods: {
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.login()
      }
    },
    destroyed() {
      window.removeEventListener('keydown', this.keyDown, false)
    },

    login() {
      if (this.language) {
        localStorage.setItem('language', 'ch')
      } else {
        localStorage.setItem('language', 'en')
      }

      this.loadding = true
      this.$Http_Post('User/GetLogin', {
        UserID: this.ruleForm.UserID,
        PWD: this.ruleForm.PWD,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.destroyed()
          this.loadding = false
          if (res.Data.roleDj == '2') {
            sessionStorage.setItem('entity', '管理员')
          } else if (res.Data.roleDj == '3') {
            sessionStorage.setItem('entity', '咨询师')
          } else if (res.Data.roleDj == '4') {
            sessionStorage.setItem('entity', '来访者')
          } else if (res.Data.roleDj == '1') {
            sessionStorage.setItem('entity', '超级管理员')
          }
          this.$store.commit('setToken', res.Data.token)
          this.$store.commit('login', res.Data)
          this.Global.birthday = res.Data.Birthday
          this.Global.userID = res.Data.UserID
          this.Global.identity = res.Data.Show
          this.Global.headPhoto = res.Data.HeadPhoto
          this.Global.roletype =
            res.Data.roleDj == '2'
              ? '管理员'
              : res.Data.roleDj == '3'
                ? '咨询师'
                : res.Data.roleDj == '4'
                  ? '来访者'
                  : '超级管理员'
          this.$message({
            message: '登录成功!',
            type: 'success',
          })

          this.$Http_Post('User/GetMenuButton').then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              sessionStorage.setItem(
                'UserGetMenuButton',
                JSON.stringify(res.Data),
              )
              this.$router.push('/ReportData/RPHome')
            }
          })
        } else {
          this.loadding = false
          this.$message.error(res.Message)
        }
      })
    },
  },
  mounted() {
    //绑定事件enter登录
    window.addEventListener('keydown', this.keyDown)
    let _this = this
    this.$Http_Post('User/GetConfigurationTable').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        _this.CompanyLogo = res.Data.CompanyLogo
        _this.SystemNM = res.Data.SystemNM
        _this.Global.companyLogo = res.Data.CompanyLogo
        _this.Global.companyNM = res.Data.SystemNM
        this.$store.commit('setSystemInfo', {
          CompanyLogo: res.Data.CompanyLogo,
          CompanyNM: res.Data.SystemNM,
        })
      }
    })
    this.$store.commit('removeToken')
    this.$store.commit('logout')
  },
}
</script>
<style>
.login h2 {
  text-align: center;
  font-size: 22px;
  padding-top: 100px;
  color: #fff;
}

.login .el-input {
  width: 80%;
}

.login {
  background-size: 100%;
  position: relative !important;
  z-index: 9 !important;
}

.login-content {
  width: 700px;
  height: 385px;
  position: fixed;
  top: -80px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  background-color: #ececec00;
  /* background-color: #fff; */
}

.login-content-left {
  width: 336px;
  height: 385px;
  float: left;
}

.login-content-left img {
  width: 100%;
  height: 100%;
}

.login-content-right {
  width: 100%;
  float: right;
  height: 100%;
  background: rgba(35, 64, 83, 1);
  border-radius: 16px;
  box-shadow: 0px 0px 10px #d4f2e6;
}

.login-content-right>div {
  font-size: 30px;
  width: 333px;
  height: 80px;
}

.login-content-right>div img {
  height: 50px;
  width: 50px;
  margin-top: 40px;
  margin-left: 30px;
}

.login-content-right>div span {
  position: absolute;
  top: 54px;
  color: #0d78e3;
  font-weight: bold;
  text-shadow: 2px 2px 2px #9dc7f1;
  font-size: 22px;
}

.login form {
  width: 100%;
  /* margin-top: 30px; */
}

.login form input {
  text-align: center;
  border: none !important;
  border-bottom: 1px solid #000 !important;
}

.login .el-input__inner {
  border: none;
  border-bottom: 1px solid #adadad !important;
  width: 80% !important;
  border-radius: 0px;
  text-align: left;
}

.login button {
  width: 300px;
  height: 46px !important;
  background-color: rgba(36, 153, 255, 1);
  border-radius: 28px;
  /* margin-top: 20px; */
  font-size: 18px;
  font-weight: bold;
}

.f {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -9999;
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  -webkit-transition: 1s opacity;
  transition: 1s opacity;
  background-color: skyblue;
}

.login {
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -10000;
  background-color: skyblue;
}

.login:before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  z-index: -1000;
  top: 0;
  left: 0;
  background: rgba(90, 20, 10, 0.2);
}

.login .el-form-item__content {
  margin-left: 75px !important;
}

.login .login-content {
  width: 450px;
  height: 400px;
  position: fixed;
  top: -80px;
  left: 45%;
  right: 0px;
  bottom: 0px;
  margin: auto;
  /* background-color: #fff; */
}

.login .el-input__inner {
  width: 100% !important;
}

.login .el-input__inner {
  width: 100% !important;
}

.login .txt_style {
  width: 100%;
  text-align: center;
  color: rgba(35, 174, 255, 1);
  font-size: 30px;
  line-height: 80px;
  text-shadow: 0px 0px 3px #cfeeb6;
}

.login .el-form-item__label {
  margin-left: 70px;
  font-size: 18px;
  color: rgba(255, 255, 255, 1);
}

.login .el-input__inner {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
}

.login .el-form-item {
  margin-bottom: 0px;
}

.login .Pass_style {
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  width: 80%;
  margin-top: 10px;
  text-align: right;
  cursor: pointer;
}
</style>
